class Entity {
  constructor (game, state) {
    this.lifeCycle = 0
    this.game = game
    this.init(state)
  }
  init () {}
  update () {}
  destroy () {}
}

export default Entity
